import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IGlobalConfig } from 'src/app/domain/registration/models/IGlobalConfig';
import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/containers/dynamic-form/dynamic-form.component';
import { PermissionService } from 'src/app/shared/permission.service';
import { GlobalConfigService } from '../crud-service';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { AbstractCrudCES } from 'src/app/shared/components/crud/abstract-crud-ces';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { GlobalConfigOriginEnum } from 'src/app/domain/registration/enums/global-config.enum';


@Component({
  selector: 'app-global-config-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.scss']
})
export class GlobalConfigCesComponent
extends AbstractCrudCES<IGlobalConfig>
implements OnInit {

  override config: IFieldConfig[] = CES_CONFIG_FIELDS;
  public filteredCities: any[] = [];

  setFields() {
    console.log('Configurando campos com dados:', this.data);

    if (this.data) {
      // Clonar os dados para não modificar o original
      const displayData = { ...this.data };

      console.log('Dados antes da conversão:', displayData);

      // Converter de decimal para porcentagem (ex: 0.03 -> 3)
      if (displayData.interest !== undefined && displayData.interest !== null) {
        displayData.interest = parseFloat((+displayData.interest * 100).toFixed(2));
        console.log('Interest após conversão:', displayData.interest);
      }

      if (displayData.fine !== undefined && displayData.fine !== null) {
        displayData.fine = parseFloat((+displayData.fine * 100).toFixed(2));
        console.log('Fine após conversão:', displayData.fine);
      }

      console.log('Preenchendo formulário com:', displayData);
      this.form.patchValue(displayData);
    } else {
      console.warn('Sem dados para preencher o formulário');
    }
  }

  constructor(
    private service: GlobalConfigService,
    public override fb: FormBuilder,
    private toastService: ToastService,
    private dialogRef: MatDialogRef<GlobalConfigCesComponent>
  ) {
    super(fb);
    this.title = `${this.typeCes} ${this.service.title.toUpperCase()}`;
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.loadActiveConfig();
  }

  private loadActiveConfig(): void {
    console.log('Iniciando carregamento da configuração ativa');

    this.service.getGlobalConfig(GlobalConfigOriginEnum.InterestAndFine).subscribe(
      (data: any) => {
        console.log('Dados recebidos da API:', data);

        // Verificação mais robusta dos dados
        if (data && (data.interest !== undefined || data.fine !== undefined)) {
          console.log('Dados válidos recebidos:', data);
          this.data = data;
          this.setFields();
        } else {
          console.error('Formato de dados inesperado ou nenhuma configuração encontrada:', data);
        }
      },
      (error) => {
        console.error('Erro ao carregar a configuração global:', error);
        this.toastService.showError('Erro ao carregar as configurações: ' + (error.error?.message || 'Erro desconhecido'));
      }
    );
  }

  ngOnDestroy() {}

  public async save() {
    if (this.form.invalid) {
      const invalidControls = this.findInvalidControls();
      let mensagem = 'Por favor, corrija os seguintes campos: ' + invalidControls.join(', ');
      this.toastService.showError(mensagem);
      return;
    }

    try {
      // Garantir que temos os valores mais recentes do formulário
      const rawFormValues = this.form.getRawValue(); // Isso obtém todos os valores, incluindo os desabilitados
      console.log('Valores brutos do formulário:', rawFormValues);

      // Copiar os valores para não modificar o original
      const formValue = {
        interest: rawFormValues.interest,
        fine: rawFormValues.fine,
        interestDescription: rawFormValues.interestDescription,
        fineDescription: rawFormValues.fineDescription,
        origin: GlobalConfigOriginEnum.InterestAndFine
      };

      // Verificar os valores específicos
      console.log('Interest antes da conversão:', formValue.interest);
      console.log('Fine antes da conversão:', formValue.fine);

      // Validar se os valores são numéricos
      if (isNaN(parseFloat(formValue.interest))) {
        this.toastService.showError('Valor de juros inválido');
        return;
      }
      if (isNaN(parseFloat(formValue.fine))) {
        this.toastService.showError('Valor de multa inválido');
        return;
      }

      formValue.interest = parseFloat(formValue.interest) / 100;
      formValue.fine = parseFloat(formValue.fine) / 100;

      console.log('Valores após conversão:', formValue);

      if (this.data && this.data.id) {
        const id = this.data.id.toString();

        // Verificar os dados antes do envio
        console.log('Enviando para o backend:', formValue);

        await this.service.update(id, formValue).subscribe(
          (responseData: any) => {
            console.log('Resposta do update:', responseData);
            this.data = responseData;
            this.setFields();
            this.toastService.showSuccess(MessagesEnum.UPDATE_SUCCESS);
            this.back();
          },
          (error) => {
            console.error('Erro no update:', error);
            this.toastService.showError('Erro ao atualizar: ' + (error.error?.message || 'Erro desconhecido'));
          }
        );
      } else {
        // Se não existe, cria um novo
        await this.service.create(formValue).subscribe(
          (data: any) => {
            this.data = data;
            this.setFields();
            this.toastService.showSuccess(MessagesEnum.CREATE_SUCCESS);
            this.back();
          },
          (error) => {
            console.error('Erro no create:', error);
            this.toastService.showError('Erro ao criar: ' + (error.error?.message || 'Erro desconhecido'));
          }
        );
      }
    } catch (error: any) {
      console.error('Erro ao processar o formulário:', error);
      this.toastService.showError('Erro ao processar o formulário: ' + error.message);
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  public back() {
    this.dialogRef.close();
  }
}
